import api from "../../../Component/axios";

export const useNotification = () => {
  const token = localStorage.getItem("@Token");

  const createNotification = async (data) => {
    try {
      await api.post("api/pedido-empaque/notificacion/", data, {
        headers: {
          Authorization: "Token " + token,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const updateNotificacion = async (id_notificacion, estatus) => {
    try {
      await api.patch(
        `api/pedido-empaque/notificacion/${id_notificacion}/`,
        { estatus: estatus },
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  return { createNotification, updateNotificacion };
};
